export default {
  confirm_submission: {
    pt: 'Confirmar envio',
    en: 'Confirm submission'
  },
  pay_and_submit: {
    pt: 'Pagar e enviar',
    en: 'Pay and submit'
  },
  submit: {
    pt: 'Enviar',
    en: 'Submit'
  }
}